import { gql } from "@apollo/client";
const GET_TEAM_USER_NOTE_COUNTS = gql`
  query getTeamUserNoteCounts(
    $startDate: DateTime
    $endDate: DateTime
    $teamUuid: String
    $jobType: String
    $filter: String
  ) {
    teamUserNoteCounts(
      startDate: $startDate
      endDate: $endDate
      teamUuid: $teamUuid
      jobType: $jobType
      filter: $filter
    ) {
      noteCounts {
        userUuid
        teamUuid
        noteCount
      }
    }
  }
`;

export default GET_TEAM_USER_NOTE_COUNTS;
